import { isWebhookBehavior } from '../../form-config/behaviors.js';
/**
 * webhook_lookup: the worked example for the AuthoringStep <-> Behavior
 * round-trip. compile spreads the step's config verbatim into the webhook
 * Behavior shape; parse lifts it back out unchanged.
 */
export function compileWebhookLookup(step) {
    return { kind: 'webhook', ...step.config };
}
/**
 * NOTE: the webhook Behavior has no field-name slot of its own — the
 * FieldDefinition it's attached to supplies that context. So `fieldName`
 * is intentionally omitted here; the caller (whoever holds the field the
 * behavior lives on) re-supplies it when reconstructing a full AuthoringStep.
 */
export function parseWebhookLookup(behavior) {
    if (!isWebhookBehavior(behavior))
        return null;
    const { kind, ...config } = behavior;
    void kind;
    return {
        effectKey: 'webhook_lookup',
        moment: 'pre_export',
        scope: 'field',
        config,
    };
}
//# sourceMappingURL=webhook-lookup.js.map